import React from 'react';
import { Layout, Avatar, Dropdown, Menu } from '@arco-design/web-react';
import { IconPoweroff, IconUser } from '@arco-design/web-react/icon';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/useAuth';
import logo from '../common/assets/logo.png';
import ProgressBar from './components/ProgressBar';
import './OnboardingLayout.css';

const { Header, Content, Footer } = Layout;

function OnboardingLayout({ children, currentStep, totalSteps, stepTitle, onStepClick, steps }) {
  const navigate = useNavigate();
  const { t } = useTranslation('onboarding');
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const userMenu = (
    <Menu onClickMenuItem={(key) => {
      if (key === 'logout') {
        handleLogout();
      }
    }}>
      <Menu.Item key="logout">
        <IconPoweroff /> {t('layout.logout')}
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout className="onboarding-layout">
      <Header className="onboarding-header">
        <div className="onboarding-header-content">
          <div className="onboarding-logo-section">
            <img src={logo} alt="SmartHub Center" className="onboarding-logo" />
            <span className="onboarding-brand-name">SmartHub Center</span>
          </div>

          <div className="onboarding-header-actions">
            <Dropdown droplist={userMenu} position="br">
              <div className="onboarding-user-menu">
                <Avatar size={32} style={{ backgroundColor: '#165DFF' }}>
                  <IconUser />
                </Avatar>
                <span className="onboarding-user-email">{user?.email}</span>
              </div>
            </Dropdown>
          </div>
        </div>
      </Header>

      {currentStep && totalSteps && (
        <div className="onboarding-progress-container">
          <ProgressBar
            currentStep={currentStep}
            totalSteps={totalSteps}
            stepTitle={stepTitle}
            onStepClick={onStepClick}
            steps={steps}
          />
        </div>
      )}

      <Content className="onboarding-content">
        <div className="onboarding-content-wrapper">
          {children}
        </div>
      </Content>

      <Footer className="onboarding-footer">
        <div className="onboarding-footer-content">
          {t('layout.footer', { year: new Date().getFullYear() })}
        </div>
      </Footer>
    </Layout>
  );
}

export default OnboardingLayout;
